import ScreenReaderLiveAnnouncer from "./ScreenReaderLiveAnnouncer";

export default ScreenReaderLiveAnnouncer;
